import { useCallback, useState } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';
import { ThemeButton } from '@ui/components/ThemeButton';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

import styles from './TournamentEditFormInputs.module.css';

export function OrgSettingsInput() {
  const [newArbiterName, setNewArbiterName] = useState('');

  const {
    control,
    formState: { disabled },
  } = useFormContext<TournamentEditFormValues>();
  const { fields, append, remove, update } = useFieldArray<
    TournamentEditFormValues,
    'orgSettings.arbiters'
  >({
    control,
    name: 'orgSettings.arbiters',
  });

  const onAdd = useCallback(() => {
    if (!newArbiterName) return;
    append({ name: newArbiterName });
    setNewArbiterName('');
  }, [newArbiterName, setNewArbiterName, append]);

  const onArbiterUpdate = useCallback(
    (updatedName: string, i: number) => {
      update(i, { name: updatedName });
    },
    [update],
  );

  return (
    <>
      <FormRow>
        <FormLabel>Главный арбитр</FormLabel>
        <FormInput>
          <Controller
            name="orgSettings.chiefArbiter"
            control={control}
            render={({ field: { value, onChange, disabled } }) => (
              <Input invisible value={value?.toString()} onChange={onChange} disabled={disabled} />
            )}
          />
        </FormInput>
      </FormRow>
      <FormRow>
        <FormLabel>Организатор</FormLabel>
        <FormInput>
          <Controller
            name="orgSettings.organizer"
            control={control}
            render={({ field: { value, onChange, disabled } }) => (
              <Input invisible value={value?.toString()} onChange={onChange} disabled={disabled} />
            )}
          />
        </FormInput>
      </FormRow>

      <FormRow>
        <FormLabel>Судьи</FormLabel>
        <FormInput className={styles.arbiters}>
          {fields.map((f, i) => {
            return (
              <div key={f.id} className={styles.arbiter}>
                <Input
                  className={styles.stretch}
                  invisible
                  value={f.name || ''}
                  onChange={(newValue) => {
                    onArbiterUpdate(newValue, i);
                  }}
                  onEnter={onAdd}
                  placeholder="ФИО судьи"
                  disabled={disabled}
                />

                <ThemeButton
                  className={styles.contactButton}
                  onClick={() => remove(i)}
                  disabled={disabled}
                >
                  Удалить
                </ThemeButton>
              </div>
            );
          })}

          <div className={styles.arbiter}>
            <Input
              className={styles.stretch}
              invisible
              value={newArbiterName}
              onChange={setNewArbiterName}
              onEnter={onAdd}
              placeholder="ФИО судьи"
              disabled={disabled}
            />

            <ThemeButton onClick={onAdd} disabled={disabled || !newArbiterName}>
              Добавить
            </ThemeButton>
          </div>
        </FormInput>
      </FormRow>
    </>
  );
}
